
import styled, { css } from 'styled-components';

const VivaThemeLogo = () => css`
position:absolute;
float:left;
top:5%;
width:${({ isDesktop }) => (isDesktop ? '200px' : '106px')};

left:${({ isDesktop }) => (isDesktop ? '10%' : '5%')};
z-index:1321;
display: ${({ show }) => (show ? 'flex' : 'none')};

@media only screen and (max-height: 500px) {
        width: 120px;
        };

`;


export default styled.div([VivaThemeLogo]);